import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'empty',
  head() {
    return {
      title: 'Extra Card Members Area - EXTRA'
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('plaid_oauth_state_id');
    const uri = window.location.search;
    window.extra_data_ul.log([{
      kingdom: 'view',
      phylum: 'page',
      class: 'members_area',
      subclass: 'oauth:plaid-in-app',
      family: id || uri ? 'success' : 'fail',
      genus: window.location.search
    }]);
    setTimeout(() => {
      this.$router.push('/');
    }, 500);
  }
};